export function addLinkHandler(value) {
  if (value) {
    const range = this.quill.getSelection();
    if (range == null || range.length === 0) return;
    let tooltip = this.quill.theme.tooltip;
    window.$('div.ql-tooltip .ql-error').remove();
    tooltip.position(this.quill.getBounds(range.index, 0));
    tooltip.edit('link', '');
    window.$('div.ql-tooltip input[type="text"]')[0].setAttribute('placeholder', 'http:// or https://');
    tooltip.save = function () {
      window.$('div.ql-tooltip .ql-error').remove();
      var url = this.textbox.value;
      let urlValidRegex =
        /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/i;
      if (url != '' && urlValidRegex.test(url)) {
        this.quill.format('link', url);
      } else {
        window
          .$(tooltip.root)
          .append('<div class="ql-error">Please enter valid url starting with "http://" or "https://".</div>');
      }
    };
  } else {
    window.$('div.ql-tooltip .ql-error').remove();
    this.quill.format('link', false);
  }
}
